import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { AlertService, IAlertType } from '../services';
import { environment } from '../../../environments/environment';

/**
 * Sperrt Routen, die auf der DEV-Stage nicht benutzt werden duerfen.
 *
 * Hintergrund: DEV und UAT leiten `/crmapi` beide auf dieselbe TecArt-Instanz
 * (`tecart.phm-burg.de`). Eine auf DEV angelegte oder geaenderte Firma landet
 * damit in den echten Kundendaten. Die Schaltflaechen dafuer sind auf DEV per
 * `*ngIf="!devMode"` ausgeblendet -- das verbirgt aber nur die Oberflaeche.
 * Die Route selbst blieb erreichbar, etwa ueber ein Lesezeichen auf
 * `/contact/add`. Diesen Weg schliesst der Guard.
 *
 * Er ist damit kein Rechtekonzept, sondern ein Schutz vor der geteilten
 * Fremdinstanz -- anders als `adminGuard`, der eine Rolle prueft.
 */
export const stageGuard: CanActivateFn = (): Observable<boolean | UrlTree> => {
  const alertDispatcher = inject(AlertService);
  const router = inject(Router);

  if (!environment.stages.dev) {
    return of(true);
  }

  alertDispatcher.show({
    message: 'Auf der DEV-Stage gesperrt: diese Seite wuerde in das produktive CRM schreiben.',
    clrAlertType: IAlertType.WARNING
  }, 6000);

  return of(router.parseUrl('/contacts/overview'));
};
